import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import ScheduleIcon from '@mui/icons-material/Schedule';
import { Box, InputAdornment, Typography } from "@mui/material";

const EditorContainer = ({
  component: Component,
  enableEdit,
  inputProps,
  multiline,
  onChange,
  placeholder,
  startIcn,
  stayInEditMode,
  style,
  value,
  ...props
}) => {
  const { disabled } = props;

  const [isEditing, setIsEditing] = useState(false);
  const [selectionIndex, setSelectionIndex] = useState(null);

  // Reference to input element (InputBase) to see cursor position
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && selectionIndex !== null && enableEdit) {
      inputRef.current?.setSelectionRange(selectionIndex, selectionIndex);
    }
  }, [isEditing, selectionIndex]);

  //Calculate what char no user is clickin at on edit
  const getSelectionIndex = () => {
    if (isEditing) {
      // Get the selection range within the InputBase component
      return inputRef.current?.selectionStart;
    } else {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        return range.startOffset;
      }
      return null;
    }
  };

  const handleEditStart = (e) => {

    //Only calculate and set cursor position if enableEdit is true
    if (enableEdit && !disabled) {
      // Calculate the cursor positions index within the Typography component
      const index = getSelectionIndex();

      //Change Typograpghy to an InputBase
      setIsEditing(true);

      // Set the selection index state
      setSelectionIndex(index);
    }
  };

  const handleChange = (e) => {
    /*const newValue = e.target?.value;
    if (newValue) {
      setInternalValue(newValue);
    }*/
  };

  const handleEditEnd = (newValue, reason) => {

    //setInternalValue(newValue);   

    onChange?.(newValue, reason);

    setIsEditing(false);
  };

  const handleBlur = (e) => {
    //handleSetIsEditing(false);
    //handleEditEnd(e.target.value);
  };

  const handleDoubleClick = (e) => {
    if (enableEdit) {
      inputRef.current?.select();
      e?.stopPropagation();
    }
  };

  const handleShiftKeyDown = (e) => e.shiftKey && e.stopPropagation();
  const handleShiftKeyUp = (e) => (e.key === "Shift") && e.stopPropagation();

  return (
    <Box
      className={isEditing ? "editingClass" : null}
      onClick={handleEditStart}
      onDoubleClick={handleDoubleClick}
      onKeyDown={handleShiftKeyDown}
      onKeyUp={handleShiftKeyUp}
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...props.sx,
        "&.MuiBox-root": {
          ...(props.sx?.["&.MuiBox-root"] || {}),
        },
      }}
    >
      {startIcn && (
        <InputAdornment position="start">
          <Box sx={{ display: 'flex', alignItems: 'center', width: "12px" }}>
            <ScheduleIcon sx={{
              opacity: 0.7, fontSize: '16px',
            }} />
          </Box>
        </InputAdornment>)}
      {isEditing && enableEdit ? (
        <Component
          autoFocus
          multiline={multiline}
          {...props}
          inputProps={{ inputProps }}
          inputRef={inputRef}
          onBlur={handleBlur}
          onChange={handleChange}
          onDoubleClick={handleDoubleClick}
          onEditEnd={handleEditEnd}
          style={{ cursor: "text", ...style }}
          sx={{ ...props.sx, }}
          value={value}
        />
      ) : (
        <Typography
          onClick={handleEditStart}
          onDoubleClick={handleDoubleClick}
          style={{ cursor: "text", ...style }}
          sx={{ ...props.sx }}
          tabIndex={0}
        >
          {value || placeholder}
        </Typography>
      )}
    </Box>
  );
};

export default EditorContainer;

EditorContainer.defaultProps = {
  enableEdit: false,
  startIcn: false,
};

EditorContainer.propTypes = {
  enableEdit: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};
